import AppLoader from './AppLoader.component';
import StaticLoader from './constant';

AppLoader.static = StaticLoader.APP_LOADER;
AppLoader.getLoaderStyle = StaticLoader.getLoaderStyle;
export default AppLoader;
